import React, { Component } from 'react';
import Loader from '../../../../components/Loader';
import Section from '../../../../components/Section';
import QuestionAnswer from './childcomponents/QuestionAnswer';
import styles from './Question.scss';
import Timer from '../../../../components/Timer';
import { getAnswerResults, getTotalResults } from './utils/getAnswerResults';

class Question extends Component {
	constructor(props) {
		super(props);
		this.timerEnabled = this.timerEnabled.bind(this);
	}

	componentWillReceiveProps(nextProps) {
		const { question, onTimerDone } = nextProps;
		if (onTimerDone) {
			if (question && question.results) {
				// if the question results are in set the current question to done: so that it shows up in the left panel (with its results)
				onTimerDone(question.id);
			} else if ((this.props.question || {}).id && (question || {}).id && (question || {}).id !== (this.props.question || {}).id && (this.props.question || {}).closeAt) {
				// if the question changed set the previous question to done: so that it shows up in the left panel
				onTimerDone(this.props.question.id);
			}
		}
	}

	timerEnabled() {
		const { question, onTimerDone } = this.props;
		return (question || {}).timer && onTimerDone;
	}

	render() {
		const {
			quiz, locale, onTimerDone, question, questionCount,
		} = this.props;
		if (!quiz) {
			return <Loader label={locale['quiz.not.started']} />;
		}
		if (!question) {
			if (!onTimerDone) {
				return <Loader label={locale['question.not.started']} />;
			}
			return <Loader label={locale['nextquestion.not.started']} />;
		}
		const total = getTotalResults(question.results);
		const doneTime = quiz.answerTime + (quiz.maxLatency || 0);
		const timerEnabled = this.timerEnabled();
		const questionText = question.skipped ? `${question.text} [skipped]` : question.text;
		return (
			<Section className={styles.root}>
				<Section.Heading>{!timerEnabled ? locale.results : locale.question}</Section.Heading>
				{onTimerDone && <p>{`Q${questionCount}`}</p>}
				<p className={styles.question}>{`${questionText}`}</p>
				{timerEnabled && (
					<div className={styles.timer}>
						<div>
							<Timer
								start={question}
								time={doneTime}
								text={locale['timer.seconds.left']}
							/>
						</div>
					</div>
				)}
				<div className={styles.list}>
					{question.answers.map((item) => {
						const { correct, count } = getAnswerResults(item.id, question.results);
						return (
							<QuestionAnswer
								key={`${item.id}`}
								answer={item}
								className={`question-item-${question.id}-${item.id}`}
								correct={correct}
								count={count}
								total={total}
							/>
						);
					})}
				</div>
			</Section>
		);
	}
}

Question.defaultProps = {};

export default Question;



// WEBPACK FOOTER //
// ./src/ui/interaction/children/sections/question/Question.component.js